<template>
  <div class="app-archive" @click="tourl">
    <img :src="archive.thumbnail || 'https://ah.download.ahedu.cn/rrt/a81f5c66-40c2-40dd-a290-10bcda553711.png'" alt="" />
    <el-tooltip class="item" effect="dark" :content="archive.name" placement="top" :disabled="archive.name.length < 12">
      <h6 class="app-archive-title">{{ archive.name }}</h6>
    </el-tooltip>

    <p class="app-archive-info">
      <span class="left">
        <!-- <span class="user" v-if="archive.createUserName">
          {{ archive.createUserName }} <el-divider direction="vertical"></el-divider>
        </span> -->
        <span class="time">{{ archive.createTime }}</span>
      </span>
      <span class="read"><i class="el-icon-view"></i> {{ archive.viewCount }}</span>
    </p>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  props: {
    archive: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  methods: {
    tourl() {
      // this.$router.push({
      //   name: 'archiveDetail',
      //   query: { detailId: this.archive.resourceId },
      // })
      let routeData = this.$router.resolve({ path: '/archive-detail', query: { detailId: this.archive.resourceId } });
      window.open(routeData.href, '_blank');
    }
  },
  computed: {},
};
</script>
<style scoped lang="less">
.app-archive {
  display: inline-block;
  margin: 0 24px 24px 0;
  cursor: pointer;
  width: 282px;
  height: 240px;
  background: linear-gradient(180deg, #e8eefb 0%, #ffffff 100%);
  box-shadow: 0px 2px 20px 0px rgba(119, 135, 182, 0.17);
  img {
    width: 282px;
    height: 154px;
  }
  .app-archive-title,
  .app-archive-info {
    padding: 0 12px;
  }
  .app-archive-title {
    margin-top: 20px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    height: 18px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 18px;
  }
  .app-archive-info {
    display: flex;
    justify-content: space-between;
    margin: 12px 0 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #8c8c8c;
    line-height: 16px;
  }
}
</style>